// Alpine.js Splide re-initialization component for Shopify Editor
export default {
  name: 'splideReinit',
  component() {
    return {
      init() {
        const reinit = () => {
          document.querySelectorAll('.splide').forEach(function (el) {
            if (el.splideInstance) {
              el.splideInstance.destroy();
            }
            try {
              var options = el.getAttribute('data-splide');
              if (options) {
                var opts = typeof options === 'string' ? JSON.parse(options) : options;
                console.log('Splide re-initialize', opts);
                el.splideInstance = new Splide(el, opts);
                el.splideInstance.mount();
                console.log('Splide re-initializ-ed', el.splideInstance);
              }
            } catch (e) {
              // Fail silently
              console.log('Could not initialize splide');
            }
          });
        };
        document.addEventListener('shopify:section:load', reinit);
        document.addEventListener('shopify:section:select', reinit);
        document.addEventListener('shopify:block:select', reinit);
        document.addEventListener('shopify:block:deselect', reinit);
        // Optionally run on Alpine init
        reinit();
      }
    }
  }
}
